import { ThemeProvider } from "@emotion/react";
import {
  createTheme,
  CssBaseline,
  GlobalStyles,
  Snackbar,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import Header from "./Header";
import Main from "./Main";
import ProgressDialog from "./ProgressDialog";
import {
  TransferQueueProvider,
  useTransferQueue,
} from "./app/transferQueue";

const globalStyles = (
  <GlobalStyles styles={{ "html, body, #root": { height: "100%" } }} />
);

const theme = createTheme({
  palette: { primary: { main: "#f38020" } },
});

function App() {
  const [search, setSearch] = useState("");
  const [showProgressDialog, setShowProgressDialog] = React.useState(false);
  const [error, setError] = useState<Error | null>(null);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <TransferQueueProvider>
        <AutoProgressDialog
          onOpenChange={setShowProgressDialog}
          onError={setError}
        />
        <Stack sx={{ height: "100%" }}>
          <Header
            search={search}
            onSearchChange={(newSearch: string) => setSearch(newSearch)}
            setShowProgressDialog={setShowProgressDialog}
          />
          <Main search={search} onError={setError} />
        </Stack>
        <Snackbar
          autoHideDuration={5000}
          open={Boolean(error)}
          message={error?.message}
          onClose={() => setError(null)}
        />
        <ProgressDialog
          open={showProgressDialog}
          onClose={() => setShowProgressDialog(false)}
        />
      </TransferQueueProvider>
    </ThemeProvider>
  );
}

// 上传/下载开始时自动弹出进度对话框
function AutoProgressDialog({
  onOpenChange,
  onError,
}: {
  onOpenChange: (show: boolean) => void;
  onError: (e: Error | null) => void;
}) {
  const transferQueue = useTransferQueue();
  const hasActive = transferQueue.some(
    (task) =>
      task.status === "pending" || task.status === "in-progress"
  );
  const hasError = transferQueue.some((task) => task.status === "failed");

  useEffect(() => {
    if (hasActive) onOpenChange(true);
  }, [hasActive, onOpenChange]);

  useEffect(() => {
    if (hasError) {
      const failed = transferQueue.find((t) => t.status === "failed");
      if (failed?.error) onError(failed.error);
    }
  }, [hasError, transferQueue, onError]);

  return null;
}

export default App;
